import { IconButton, TextField, Typography } from '@mui/material'
import React from 'react'
import ClearRoundedIcon from '@mui/icons-material/ClearRounded'
import TokTokDocDialog from '../../../Common/Dialog'
import { riskyChars, validate } from './mediaRenamerUtils'
import { pictureExt, documentExt } from '../../../../api/media'
import useStyles from './_styles'

/**
 * @description media renaming dialog
 * @param {Boolean} open set the dialog open
 * @param {Function} handleClose triggers on dialog close
 * @param {Object} mediaTarget the media object
 * @param {Function} onSave triggers on dialog save
 * @param {Object<Array>} existingNames list of existing protected names
 * @returns
 */
const MediaRenamer = ({
    open = false,
    handleClose = () => undefined,
    mediaTarget = null,
    onSave = () => undefined,
    existingNames = [],
}) => {
    const classes = useStyles()

    const [isNameValid, setIsNameValid] = React.useState(undefined)
    const [renamingErrors, setRenamingErrors] = React.useState([])
    const [newMediaName, setNewMediaName] = React.useState(null)
    const [targetType, setTargetType] = React.useState(undefined)
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    const [value, setValue] = React.useState(mediaTarget.name)

    // @ts-expect-error TS(2554) FIXME: Expected 0 arguments, but got 1.
    const inputRef = React.createRef(null)

    React.useEffect(() => {
        if (mediaTarget) {
            // @ts-expect-error TS(2339) FIXME: Property 'ext' does not exist on type 'never'.
            if (pictureExt.includes(mediaTarget.ext)) {
                // @ts-expect-error TS(2345) FIXME: Argument of type '"pictures"' is not assignable to... Remove this comment to see the full error message
                setTargetType('pictures')
                // @ts-expect-error TS(2339) FIXME: Property 'ext' does not exist on type 'never'.
            } else if (documentExt.includes(mediaTarget.ext)) {
                // @ts-expect-error TS(2345) FIXME: Argument of type '"documents"' is not assignable t... Remove this comment to see the full error message
                setTargetType('documents')
            } else {
                setTargetType(undefined)
            }
        }
    }, [mediaTarget])

    const onChange = (e: any) => {
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        const { isValid, errors } = validate(e.target.value, existingNames, targetType, mediaTarget.name)
        setValue(e.target.value)

        // @ts-expect-error TS(2345) FIXME: Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
        setIsNameValid(isValid)
        // @ts-expect-error TS(2345) FIXME: Argument of type 'string[] | ("Ce nom dépasse 35 c... Remove this comment to see the full error message
        setRenamingErrors(errors)

        if (isValid) {
            setNewMediaName(e.target.value)
        }
    }

    const buildMediaWithNewName = () => {
        const result = {
            id: null,
            newName: null,
        }
        if (isNameValid) {
            // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
            result.id = mediaTarget.id
            result.newName = newMediaName
        } else {
            console.log('Invalid new media name')
        }
        return {
            ...result,
        }
    }

    const renderRenamingDialogHint = () => (
        <div className={classes.MediaRenamerContentAlert}>
            <Typography>
                <span>
                    Le nouveau nom doit être <strong>unique</strong>, sa longueur est limitée à{' '}
                </span>
                <strong>35 caractères</strong>.
            </Typography>
            <Typography>
                Il peut être composé de <strong>lettres</strong> et de <strong>chiffres</strong>.
            </Typography>
            <Typography>
                <span>Les caractères spéciaux </span>
                {riskyChars.map((char) => (
                    <span className={classes.MediaRenamerContentAlertRiskyChar} key={char}>
                        {char}
                    </span>
                ))}
                <span>sont interdits.</span>
            </Typography>
        </div>
    )

    try {
        return (
            <TokTokDocDialog
                isOpen={open}
                handleClose={handleClose}
                handleSave={() => {
                    const mediaWithNewName = buildMediaWithNewName()
                    // @ts-expect-error TS(2554) FIXME: Expected 0 arguments, but got 1.
                    onSave(mediaWithNewName)
                }}
                saveTitle="Renommer"
                // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
                title={`Renommer l'élément "${mediaTarget.name}" ?`}
                disableCondition={[undefined, false].includes(isNameValid)}
                classNames={{
                    root: classes.MediaRenamerRoot,
                }}
            >
                <div className={classes.MediaRenamerContent}>
                    <div className={classes.MediaRenamerContentItem}>{renderRenamingDialogHint()}</div>
                    <div className={classes.MediaRenamerContentItem}>
                        <TextField
                            variant="outlined"
                            label="Nouveau nom de l'élément"
                            onInput={onChange}
                            helperText={renamingErrors ? renamingErrors.join(' ') : null}
                            error={isNameValid === false}
                            onBlur={onChange}
                            value={value}
                            inputProps={{
                                ref: inputRef,
                            }}
                            // linter case misread
                            // eslint-disable-next-line react/jsx-no-duplicate-props
                            InputProps={{
                                endAdornment: (
                                    <IconButton
                                        onClick={() => {
                                            setValue('')
                                            if (inputRef?.current) {
                                                // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
                                                inputRef.current.focus()
                                            }
                                        }}
                                    >
                                        <ClearRoundedIcon />
                                    </IconButton>
                                ),
                            }}
                        />
                    </div>
                </div>
            </TokTokDocDialog>
        )
    } catch (error) {
        console.log(error)
        return null
    }
}

export default MediaRenamer
